import IDP_CONFIG from './idp-config';
import {createSessionCache, TabSession} from './tabSession';

// Access is deferred so a browser storage restriction becomes a visible session error,
// rather than an exception while importing the application.
const storage: Storage = {
    get length() { return window.sessionStorage.length; },
    getItem: key => window.sessionStorage.getItem(key),
    setItem: (key, value) => window.sessionStorage.setItem(key, value),
    removeItem: key => window.sessionStorage.removeItem(key),
    key: index => window.sessionStorage.key(index),
    clear: () => { throw new Error('The application must never clear all tab storage.'); },
};

const namespace = `outlaw:auth:v1:${window.location.origin}:${IDP_CONFIG.domain}:${IDP_CONFIG.clientId}`;
export const tabSession = new TabSession(storage, namespace, {
    // Auth0 publishes `iss` with a trailing slash; Zitadel without one.
    issuer: IDP_CONFIG.provider === 'zitadel' ? `https://${IDP_CONFIG.domain}` : `https://${IDP_CONFIG.domain}/`,
    clientId: IDP_CONFIG.clientId, audience: IDP_CONFIG.audience, provider: IDP_CONFIG.provider,
});
export const sessionCache = createSessionCache(storage, namespace, tabSession.reportStorageFailure);
